import tinymce from "./tinymce";
import {Modal} from "bootstrap";
import naja from "naja";
import sortable from "html5sortable/src/html5sortable";

export default function(html) {
	const form = html.querySelector('form#frm-articleManager-articleForm')
	if (form) {
		const ajaxStartCallback = (event) => {
			if (event.detail.request.method !== 'GET') {
				html.querySelector('#ajaxLoader')?.classList.remove('d-none')
			}

			html.querySelectorAll('.modal').forEach((el) => {
				if (!el.dataset.ajaxHideSkip) {
					Modal.getInstance(el)?.hide();
				}
			})
		}

		const snippetAfterUpdateCallback = () => {
			html.querySelector('#ajaxLoader')?.classList.add('d-none')
		}

		naja.removeEventListener('start', ajaxStartCallback)
		naja.addEventListener('start', ajaxStartCallback)

		naja.snippetHandler.removeEventListener('afterUpdate', snippetAfterUpdateCallback)
		naja.snippetHandler.addEventListener('afterUpdate', snippetAfterUpdateCallback)

		const redirectHandler = (event) => {
			if (!event.detail.url.includes('editorMode=')) {
				event.detail.setHardRedirect(true)
			}
		}

		naja.redirectHandler.removeEventListener('redirect', redirectHandler)
		naja.redirectHandler.addEventListener('redirect', redirectHandler)


		form.querySelectorAll('.modal.topics .topic').forEach((topic) => {
			topic.classList.add('d-none')
		})

		form.querySelectorAll('input[type=radio][name=template]').forEach((el) => {
			el.addEventListener('change', (e) => {
				form.querySelectorAll('.modal.topics .topic').forEach((topic) => {
					topic.classList.add('d-none')
				})

				form.querySelectorAll('.modal.topics [data-article-template-' + e.currentTarget.value + ']').forEach((topic) => {
					topic.classList.remove('d-none')
				})
			})
		})

		const template = form.querySelector('input[type=radio][name=template]:checked')
		if (template) {
			form.querySelectorAll('.modal.topics [data-article-template-' + template.value + ']').forEach((topic) => {
				topic.classList.remove('d-none')
			})
		}

		for (let selector of ['#topic1Modal', '#topic2Modal']) {
			const btn = html.querySelector('button[data-bs-target="' + selector + '"]')

			html.querySelectorAll(selector + ' input[type=radio]').forEach((el) => {
				el.addEventListener('change', (e) => {
					btn.classList.add('placeholder')
					btn.classList.remove('btn')
					btn.classList.remove('btn-outline-blue')
					btn.classList.remove('text-uppercase')
					btn.textContent = btn.dataset.text

					const el = e.target
					if (el.checked) {
						btn.classList.remove('placeholder')
						btn.classList.add('btn')
						btn.classList.add('btn-outline-blue')
						btn.classList.add('text-uppercase')
						btn.textContent = el.nextElementSibling.textContent
					}
				})
			})

			html.querySelector(selector + ' button.reset').addEventListener('click', (e) => {
				e.preventDefault()

				e.currentTarget.closest('.modal').querySelectorAll('input[type=radio]').forEach((el) => {
					el.checked = false

					btn.classList.add('placeholder')
					btn.classList.remove('btn')
					btn.classList.remove('btn-outline-blue')
					btn.classList.remove('text-uppercase')
					btn.textContent = btn.dataset.text
				})
			})
		}

		form.querySelectorAll('textarea[rows="1"]').forEach((el) => {
			el.addEventListener('keydown', (e) => {
				if (e.keyCode === 13) {
					e.preventDefault()
				}
			})
		})

		form.querySelectorAll('[data-tinymce]').forEach((el) => {
			el.addEventListener('focus', (e) => {
				e.currentTarget.previousElementSibling.classList.remove('visually-hidden');

				tinymce({
					selector: 'textarea#' + e.currentTarget.getAttribute('id') + '[data-tinymce]',
					height: 360,
					autofocus: true
				})

				window.tinymce.get(e.currentTarget.getAttribute('id'))?.show()
			})
		})

		form.querySelectorAll('.tinymce-helper').forEach((el) => {
			el.addEventListener('click', (e) => {
				const parent = e.currentTarget.parentElement
				const helper = parent.querySelector('.tinymce-helper')
				helper.classList.add('d-none')

				const input = parent.querySelector('[data-tinymce]')
				input.classList.remove('d-none')
				input.focus()

				const editor = window.tinymce.get(input.getAttribute('id'))
				editor.show()
				editor.focus()
			})
		})

		form.querySelectorAll('.upload-helper, .upload-more').forEach((el) => {
			const input = el.querySelector('input[type=file]')
			input?.addEventListener('change', (e) => {
				const multiple = e.currentTarget.hasAttribute('multiple')
				let row = el.classList.contains('upload-more')
					? e.currentTarget.closest('.upload-more').previousElementSibling.previousElementSibling
					: e.currentTarget.closest('.upload-helper').nextElementSibling

				row.querySelectorAll('.img-preview.not-uploaded, .file-preview.not-uploaded').forEach((el) => {
					el.remove()
				})

				for (const file of e.target.files) {
					if (file.type.startsWith("image/")) {
						const col = document.createElement("div")
						const remove = document.createElement("button")
						const img = document.createElement("img")

						col.classList.add('img-preview')
						col.classList.add('not-uploaded')
						if (multiple) {
							col.classList.add('multiple')
						}

						remove.setAttribute('type', 'button')
						remove.classList.add('remove')

						remove.innerHTML = '<i class="fas fa-times"></i>'
						remove.addEventListener('click', (e) => {
							row.querySelectorAll('.img-preview.not-uploaded, .file-preview.not-uploaded').forEach((el) => {
								el.remove()
							})

							input.value = null

							if (row.querySelectorAll('.img-preview, .file-preview').length === 0) {
								el.classList.remove('d-none')
								el.parentElement.querySelector('.upload-more')?.classList.add('d-none')
							}
						})

						img.file = file
						img.classList.add('img-fluid')
						if (multiple) {
							img.setAttribute('style', 'max-height: 120px')
						}

						col.appendChild(remove)
						col.appendChild(img)
						row.appendChild(col)

						el.parentElement.querySelector('.upload-more')?.classList.remove('d-none')

						const reader = new FileReader()
						reader.onload = () => {
							if (typeof  reader.result === 'string') {
								img.src = reader.result
							}
						}
						reader.readAsDataURL(file)

					} else {
						const col = document.createElement("div")
						const text = document.createElement("div")
						const remove = document.createElement("button")

						col.classList.add('file-preview')
						col.classList.add('not-uploaded')
						if (multiple) {
							col.classList.add('multiple')
						}

						remove.setAttribute('type', 'button')
						remove.classList.add('remove')

						remove.innerHTML = '<i class="fas fa-times"></i>'
						remove.addEventListener('click', (e) => {
							row.querySelectorAll('.img-preview.not-uploaded, .file-preview.not-uploaded').forEach((el) => {
								el.remove()
							})

							input.value = null

							if (row.querySelectorAll('.img-preview, .file-preview').length === 0) {
								el.classList.remove('d-none')
								el.parentElement.querySelector('.upload-more')?.classList.add('d-none')
							}
						})

						text.classList.add('file')
						text.classList.add('text-nowrap')
						text.innerHTML = '<i class="fas fa-file me-2"></i>' + file.name

						col.appendChild(remove)
						col.appendChild(text)
						row.appendChild(col)

						el.parentElement.querySelector('.upload-more')?.classList.remove('d-none')
					}
				}

				if (!el.classList.contains('upload-more')) {
					el.classList.add('d-none')
				}
			})
		})

		html.querySelectorAll('input[name=section]').forEach((el) => {
			el.addEventListener('change', (e) => {
				const web = html.querySelector('input[name=parentWeb]').closest('.web')
				const intranet = html.querySelector('input[name=parentIntranet]').closest('.intranet')
				const value = e.currentTarget.value

				if (web && intranet) {
					const webText = web.querySelector('.form-text')
					const intranetText = intranet.querySelector('.form-text')

					web.classList.add('d-none')
					webText.classList.add('d-none')
					intranet.classList.add('d-none')
					intranetText.classList.add('d-none')

					if (value === 'web') {
						web.classList.remove('d-none')

					} else if (value === 'intranet') {
						intranet.classList.remove('d-none')

					} else if (value === 'both') {
						web.classList.remove('d-none')
						webText.classList.remove('d-none')
						intranet.classList.remove('d-none')
						intranetText.classList.remove('d-none')
					}
				}
			})
		})

		html.querySelectorAll('input[name=otherArticles]').forEach((el) => {
			el.addEventListener('change', (e) => {
				const value = e.currentTarget.value
				const root = e.currentTarget.closest('.d-flex')
				const auto = root.querySelectorAll('.auto')
				const custom = root.querySelectorAll('.custom')

				auto.forEach((el) => {
					el.classList.add('d-none')
				})

				custom.forEach((el) => {
					el.classList.add('d-none')
				})

				if (value === 'auto') {
					auto.forEach((el) => {
						el.classList.remove('d-none')
					})

				} else if (value === 'custom') {
					custom.forEach((el) => {
						el.classList.remove('d-none')
					})
				}
			})
		})

		html.querySelectorAll('.img-preview button.remove, .file-preview button.remove').forEach((el) => {
			el.addEventListener('click', (e) => {
				const root = e.currentTarget.closest('.d-flex')
				const stack = root.nextElementSibling
				stack.value += e.currentTarget.dataset.id + ';'

				e.currentTarget.closest('.img-preview')?.remove()
				e.currentTarget.closest('.file-preview')?.remove()

				if (root.querySelectorAll('.img-preview, .file-preview').length === 0) {
					root.previousElementSibling.classList.remove('d-none')
					root.parentElement.querySelector('.upload-more')?.classList.add('d-none')
				}
			})
		})

		form.querySelectorAll('input[type=radio][name=section]').forEach((el) => {
			el.addEventListener('change', (e) => {
				form.querySelectorAll('.modal.departments .department').forEach((department) => {
					department.classList.add('d-none')
				})

				const values = e.currentTarget.value === 'both' ? ['web', 'intranet'] : [e.currentTarget.value]
				for (let value of values) {
					form.querySelectorAll('.modal.departments [data-' + value + ']').forEach((department) => {
						department.classList.remove('d-none')
					})
				}
			})
		})

		const section = form.querySelector('input[type=radio][name=section]:checked')
		if (section) {
			const values = section.value === 'both' ? ['web', 'intranet'] : [section.value]
			for (let value of values) {
				form.querySelectorAll('.modal.departments [data-' + value + ']').forEach((department) => {
					department.classList.remove('d-none')
				})
			}
		}

		for (let section of ['web', 'intranet']) {
			const selector = '[data-bs-toggle=modal][data-' + section + '-url]'
			html.querySelectorAll(selector).forEach((el) => {
				el.addEventListener('click', (e) => {
					const loader = document.querySelector('#contentPreviewLoader')
					loader.classList.remove('d-none')

					const iframe = document.querySelector('#contentPreviewModal iframe.' + section)
					iframe.classList.add('d-none')

					const url = e.currentTarget.getAttribute('data-' + section + '-url')
					if (url) {
						const callback = (e) => {
							loader.classList.add('d-none')
							e.currentTarget.classList.remove('d-none')
						}

						iframe.removeEventListener('load', callback)
						iframe.addEventListener('load', callback)

						iframe.setAttribute('src', url)

					} else {
						alert('URL not found.')
					}
				})
			})
		}

		form.querySelectorAll('input[type=checkbox][name="departments[]"]').forEach((el) => {
			el.addEventListener('change', (e) => {
				const value = e.currentTarget.value

				const box = form.querySelector('.departments-box')
				const list = form.querySelector('.departments-list')

				if (el.checked) {
					box.classList.add('d-none')
					list.querySelector('[data-code="' + value + '"]')?.classList.remove('d-none')

				} else {
					list.querySelector('[data-code="' + value + '"]')?.classList.add('d-none')

					if (form.querySelectorAll('input[type=checkbox][name="departments[]"]:checked').length === 0) {
						box.classList.remove('d-none')
					}
				}
			})
		})

		const gallery = sortable('.sortable-gallery', {
			forcePlaceholderSize: true,
			placeholder: '<div class="sortable-placeholder"><div class="placeholder-area">' + html.querySelector('.sortable-gallery').dataset.placeholderText + '</div></div>',
			acceptFrom: '.sortable-gallery'
		})[0]

		gallery.addEventListener('sortstart', (e) => {
			const height = e.detail.item.offsetHeight
			const interval = setInterval(() => {
				const ph = e.detail.item.closest('.sortable-gallery').querySelector('.sortable-placeholder')
				if (ph) {
					clearInterval(interval)
					ph.className += ' ' + e.detail.item.className
					ph.classList.remove('sortable-dragging')
					ph.querySelector('.placeholder-area').style.height = `${height}px`
					ph.style.height = height + 'px'
				}
			}, 10)
		})

		gallery.addEventListener('sortupdate', (e) => {
			const fileId = e.detail.item.dataset.fileId
			const destination = e.detail.destination.index

			const url = e.detail.item.closest('.sortable-gallery').dataset.url
			naja.makeRequest('GET', url, {
				fileId: fileId,
				destination: destination
			}, {history: false}).catch((err) => {
				alert(err)
			})
		})


		const attachemnts = sortable('.sortable-attachments', {
			forcePlaceholderSize: true,
			placeholder: '<div class="sortable-placeholder"><div class="placeholder-area">' + html.querySelector('.sortable-attachments').dataset.placeholderText + '</div></div>',
			acceptFrom: '.sortable-attachments'
		})[0]

		attachemnts.addEventListener('sortstart', (e) => {
			const height = e.detail.item.offsetHeight
			const interval = setInterval(() => {
				const ph = e.detail.item.closest('.sortable-attachments').querySelector('.sortable-placeholder')
				if (ph) {
					clearInterval(interval)
					ph.className += ' ' + e.detail.item.className
					ph.classList.remove('sortable-dragging')
					ph.querySelector('.placeholder-area').style.height = `${height}px`
					ph.style.height = height + 'px'
				}
			}, 10)
		})

		attachemnts.addEventListener('sortupdate', (e) => {
			const fileId = e.detail.item.dataset.fileId
			const destination = e.detail.destination.index

			const url = e.detail.item.closest('.sortable-attachments').dataset.url
			naja.makeRequest('GET', url, {
				fileId: fileId,
				destination: destination
			}, {history: false}).catch((err) => {
				alert(err)
			})
		})
	}
}
